export enum LoadingStatusEnum {
  noData = 'noData',
  loading = 'loading',
  loaded = 'loaded',
  error = 'error',
}
